import React from 'react';
import { stats } from '../data/hero';
export function Stats() {
  return <section aria-label="Real results" className="border-y border-grape/10 bg-white/70" data-id="element-157" data-mp="2wxq9bxqydsbk">
      <div className="mx-auto max-w-5xl px-5 py-8" data-id="element-158" data-mp="2wvdtpr8o3u1o">
        <dl className="grid grid-cols-2 gap-6 sm:grid-cols-4" data-id="element-159" data-mp="2ix5rp4wry2jn">
          {stats.map(s => <div key={s.label} className="text-center" data-id="element-160" data-mp="2nvz9h9j3gfpm">
              <dt className="font-display text-4xl font-black text-plum sm:text-5xl" data-id="element-161" data-mp="2985tvou0dd71">{s.value}</dt>
              <dd className="mt-1 text-sm font-medium text-plum/60" data-id="element-162" data-mp="2dyujszq1i242">{s.label}</dd>
            </div>)}
        </dl>
      </div>
    </section>;
}